module.exports = __webpack_public_path__ + "img/defaultAvatar.7e826661.png";